export class ColorInterpolator {
	// Returns a single rgb color interpolation between given rgb color
	// based on the factor given; via https://codepen.io/njmcode/pen/axoyD?editors=0010
	public interpolateColor(color1, color2, factor) {
		if (arguments.length < 3) {
			factor = 0.5;
		}
		var result = color1.slice();
		for (var i = 0; i < 3; i++) {
			result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
		}
		return result;
	};
	// My function to interpolate between two colors completely, returning an array
	public interpolateColors(color1, color2, steps) {
		var stepFactor = 1 / (steps - 1),
			interpolatedColorArray = [];

		color1 = color1.match(/\d+/g).map(Number);
		color2 = color2.match(/\d+/g).map(Number);

		for (var i = 0; i < steps; i++) {
			interpolatedColorArray.push(this.interpolateColor(color1, color2, stepFactor * i));
		}

		return interpolatedColorArray;
	}

	public interpolateColorsAsRGBFormat(color1, color2, steps) {
		return this.interpolateColors(color1, color2, steps).map(x => {
			let formatedColor = `rgb(${x[0]}, ${x[1]}, ${x[2]})`;
			return formatedColor;
		})
	}
}